"use strict";
import React from "react";
import _ from "underscore";
import Account from "../../api/account";
import CarrierTypeAhead from "../carrier_typeahead";
import LinkedStateMixin from "react-addons-linked-state-mixin";
import ValueLinkTextDroppableInput from "../value_link_text_droppable_input";
export default React.createClass({
  mixins: [LinkedStateMixin],
  getInitialState: function() {
    var initial = this.stateFromProps(this.props);
    initial.advancedSearch = false;
    return initial;
  },
  stateFromProps: function(props) {
    return {
      carrier_id: props.carrier ? props.carrier.id : void 0,
      carrier: this.carrierFromProps(props),
      userSelectedCarrier: false
    };
  },
  componentDidMount: function() {
    var self = this;
    if (this.props.carrier.promise) {
      this.props.carrier.promise.then(function(result) {
        self.setState({ carrier: result.carrier });
      });
    }
  },
  componentWillReceiveProps: function(newProps) {
    if (!this.state.userSelectedCarrier) {
      this.setState(this.stateFromProps(newProps));
    }
  },
  // STATE
  //
  selectCarrier: function(carrier) {
    this.setState({
      carrier_id: carrier ? carrier.id : void 0,
      carrier,
      userSelectedCarrier: true
    });
  },
  search: function(e) {
    if (e) e.preventDefault();
    this.props.onSearch(this.terms());
  },
  terms: function() {
    return _.object(
      _.reject(_.pairs(this.state), function(pair) {
        return _.first(pair) === "carrier";
      })
    );
  },
  toggleAdvancedFields: function() {
    this.setState({ advancedSearch: !this.state.advancedSearch });
  },
  carrierFromProps: function(props) {
    return props.carrier.id ? props.carrier : null;
  },
  // RENDERING
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "import-detail__search " }, /* @__PURE__ */ React.createElement("form", { onSubmit: this.search }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "id-or-reference" }, "ID or Reference"), /* @__PURE__ */ React.createElement(
      ValueLinkTextDroppableInput,
      {
        id: "id-or-reference",
        type: "text",
        autoFocus: true,
        valueLink: this.linkState("reference"),
        className: "mousetrap-allow-text"
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, /* @__PURE__ */ React.createElement("label", null, Account.carrierTerm()), /* @__PURE__ */ React.createElement(
      CarrierTypeAhead,
      {
        carrier: this.state.carrier,
        onSelectCarrier: this.selectCarrier,
        onClearCarrier: this.selectCarrier
      }
    ))), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 columns load-search-form__advanced-search-toggle" }, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("a", { onClick: this.toggleAdvancedFields }, "Advanced search")))), this.advancedFields(), /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, this.searchButton()))));
  },
  searchButton: function() {
    if (this.props.searching) {
      return /* @__PURE__ */ React.createElement("button", { disabled: true, className: "small" }, "Searching...");
    } else {
      return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("button", { type: "submit", className: "button--confirmation" }, "Search"), " ", /* @__PURE__ */ React.createElement("span", { className: "load-search-form__cancel-or" }, "or "), /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "load-search-form__cancel-link",
          onClick: this.props.onCancel
        },
        "cancel"
      ));
    }
  },
  advancedFields: function() {
    if (this.state.advancedSearch) {
      return /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, /* @__PURE__ */ React.createElement("label", null, "Start Ship Date"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "date",
          value: this.state.ship_start || "",
          onChange: (e) => this.setState({
            ship_start: e.target.value
          })
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "large-5 columns" }, /* @__PURE__ */ React.createElement("label", null, "End Ship Date"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "date",
          value: this.state.ship_end || "",
          onChange: (e) => this.setState({
            ship_end: e.target.value
          })
        }
      )));
    }
  }
});
